import { render, staticRenderFns } from "./AuthLogin.vue?vue&type=template&id=0875042c&scoped=true&"
import script from "./AuthLogin.vue?vue&type=script&lang=js&"
export * from "./AuthLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0875042c",
  null
  
)

export default component.exports